import { style } from '@vanilla-extract/css'

import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'

export const profileCardList__col4 = style({})

export const profileCardList = style({
  display: 'block',
})

export const profileCardList_items = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  columnGap: 16,
  rowGap: 32,

  '@media': {
    [getMediaQuery('md')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },

    [getMediaQuery('lg')]: {
      gridTemplateColumns: 'repeat(4, 1fr)',
    },
  },
})

export const profileCardList_item = style({})
